import { usePdf, usePdfJump } from '@anaralabs/lector';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { match } from 'ts-pattern';
import { highlightAtom } from './PDFViewer';

interface HighlightManagerProps {
  currentLoadedUrl: string | null;
  documentUrl: string;
}
export const HighlightManager = ({
  currentLoadedUrl,
  documentUrl,
}: HighlightManagerProps) => {
  const [highlight, setHighlight] = useAtom(highlightAtom);

  const viewport = usePdf((state) => state.viewportRef);
  const zoom = usePdf((state) => state.zoom);

  const { jumpToPage, jumpToHighlightRects } = usePdfJump();

  useEffect(() => {
    const isCurrentChatbotLoaded = documentUrl === currentLoadedUrl;

    if (!highlight || !isCurrentChatbotLoaded) return;

    setTimeout(() => {
      match(highlight)
        .with({ type: 'page' }, ({ pageNumber }) => {
          jumpToPage(pageNumber);
        })
        .with({ type: 'chunk' }, ({ rects, rectType }) => {
          const viewportHeight = viewport?.current?.clientHeight ?? 300;
          const offset = viewportHeight / 2 / zoom - viewportHeight / 5;

          jumpToHighlightRects(rects, rectType, 'start', -offset);
        })
        .otherwise(() => {});

      setHighlight(null);
    }, 200);
  }, [
    highlight,
    currentLoadedUrl,
    documentUrl,
    jumpToPage,
    jumpToHighlightRects,
  ]);

  return null;
};
